module.exports = __webpack_public_path__ + "img/d201305-2.1c49f587.jpg";